/**
 * Loading skeleton for the Compare Sales dialog body. Approximates the
 * two-system compare table (LS | Xero panel headers, a column-header strip,
 * line-item rows) plus the payments box below it, so a cold deep-link open
 * shows structure-in-place rather than a centred spinner - the same skeleton
 * approach the exception drawer uses (ExceptionDrawerPanel).
 */
import React from 'react'
import { Box, Skeleton, Stack } from '@mui/material'

const CompareSalesSkeleton: React.FC = () => (
  <Box sx={{ pt: 1.5, pb: 2, px: 2 }} aria-busy="true" data-testid="compare-sales-skeleton">
    {/* LS | Xero system-panel headers */}
    <Stack direction="row" spacing={1.5} sx={{ mb: 1 }}>
      <Skeleton variant="rounded" height={48} sx={{ flex: 1 }} />
      <Skeleton variant="rounded" height={48} sx={{ flex: 1 }} />
    </Stack>
    {/* Column-header strip */}
    <Skeleton variant="rounded" height={28} sx={{ mb: 1 }} />
    {/* Line-item rows */}
    <Stack spacing={0.75}>
      {Array.from({ length: 6 }).map((_, i) => (
        <Skeleton key={i} variant="rounded" height={36} />
      ))}
    </Stack>
    {/* Totals + payments box */}
    <Skeleton variant="rounded" height={72} sx={{ mt: 1.5 }} />
  </Box>
)

export default CompareSalesSkeleton
